import React, { Component } from 'react';
import './UI.css';

class Loader extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className ="loader-container">
                <div>
                    <div className="loader"></div>
                </div>

                <div className="loader-text">{this.props.text}</div>
            </div>

        );
    }

}
export default Loader;